<header class="header header--active">
    <div class="header-logo">
        <a [routerLink]="defaultUrl" routerLinkActive="active">
            <img
              [style.width]="logo?.width"
              [style.height]="logo?.height"
              *ngIf="logoImagePath !== ''"
              [src]="logoImagePath" alt="Home">
        </a>
    </div>
    <div *ngIf="showMenu" class="header-search-xs-wrapper">
        <div class="mobile-icons hidden-sm-up">
            <div class="open-menu" [class.active]="menuActive" (click)="toggleClassMenu()">
            </div>
        </div>
    </div>
    <nav class="header-navigation" *ngIf="showMenu && !isMaintenance" [class.active]="menuActive">
        <div class="navigation-links">
            <ul>
                <li *ngFor="let menuItem of menuItems" [routerLinkActiveOptions]="{exact: true}" [routerLinkActive]="'active'" class="list-item">
                    <a class="navigation" *ngIf="menuItem.type !== 'external'" [routerLink]="menuItem.state">
                      {{menuItem.name == 'Posts' ? 'News and Events' : menuItem.name}}
                    </a>
                  <a class="navigation" *ngIf="menuItem.type === 'external'" href="{{menuItem.state}}" [target]="getTargetValue(menuItem.type)">
                    {{menuItem.name == 'Posts' ? 'News and Events' : menuItem.name}}
                  </a>
                </li>
            </ul>
        </div>
    </nav>
</header>
